import type {
  BookingDisclaimer,
  CheckoutPremierRetouching,
  CheckoutPrepayCard,
  CheckoutPrepayPage
} from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

import { premierRetouchingPlaceholder } from '@/content/placeholderImages'

// ---------------------------------------------------------------------------
// CMS-typed fallback by API bundle identifier
// ---------------------------------------------------------------------------

export const prepayCardFallbacks: Record<string, CheckoutPrepayCard> = {
  PREPAY_ALLDIGITALS: {
    internalName: '',
    identifier: '',
    headerTitle: '',
    productName: '',
    heading: '',
    orderSummaryFriendlyName: '',
    body: '',
    badgeLabel: '',
    disclaimer: '',
    promoBadge: '',
    ctaLabel: '',
    images: []
  } as unknown as CheckoutPrepayCard,
  PREPAY_DIGITAL_PORTFOLIO: {
    internalName: '',
    identifier: '',
    headerTitle: '',
    productName: '',
    heading: '',
    orderSummaryFriendlyName: '',
    body: '',
    badgeLabel: '',
    disclaimer: '',
    promoBadge: '',
    ctaLabel: '',
    images: []
  } as unknown as CheckoutPrepayCard,
  PREPAY_BASIC_ALLDIGITALS: {
    internalName: '',
    identifier: '',
    headerTitle: '',
    productName: '',
    heading: '',
    orderSummaryFriendlyName: '',
    body: '',
    badgeLabel: '',
    disclaimer: '',
    promoBadge: '',
    ctaLabel: '',
    images: []
  } as unknown as CheckoutPrepayCard
}

// ---------------------------------------------------------------------------
// CMS fallback — CheckoutPrepayPage (page-level labels)
// ---------------------------------------------------------------------------

export const checkoutPrepayPageFallback = {
  internalName: '',
  pageHeading: '',
  pageSubtitle: '',
  sectionHeading: '',
  sectionSubheading: '',
  ctaLabel: '',
  skipLabel: '',
  buyLaterLabel: '',
  satisfactionGuarantee: '',
  processingFeeDisclosureLabel: '',
  processingFeeDisclosureBody: '',
  cards: []
} as unknown as CheckoutPrepayPage

export const checkoutPrepayDisclaimerFallback: BookingDisclaimer = {
  internalName: '',
  identifier: '',
  preview: '',
  body: '',
  expandLabel: '',
  collapseLabel: ''
}

// ---------------------------------------------------------------------------
// CMS fallback — CheckoutPremierRetouching (standalone singleton)
// ---------------------------------------------------------------------------

export const checkoutPremierRetouchingFallback: CheckoutPremierRetouching = {
  internalName: '',
  heading: '',
  headingTemplate: '',
  body: '',
  image: { assetId: '', alt: '', url: '' },
  addButtonLabel: '',
  declineButtonLabel: '',
  alreadySelectedLabel: '',
  orderSummaryFriendlyName: ''
}

/**
 * Local fallback image for premier retouching — used when CMS image URL is empty.
 * The component handles the transform (principle 4).
 */
export const premierRetouchingFallbackImage = {
  src: premierRetouchingPlaceholder,
  alt: 'Premier Retouching before and after comparison'
}
